import { render, staticRenderFns } from "./CheckTag.vue?vue&type=template&id=1ca22a6c&scoped=true&"
import script from "./CheckTag.vue?vue&type=script&lang=js&"
export * from "./CheckTag.vue?vue&type=script&lang=js&"
import style0 from "./CheckTag.vue?vue&type=style&index=0&id=1ca22a6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca22a6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ca22a6c')) {
      api.createRecord('1ca22a6c', component.options)
    } else {
      api.reload('1ca22a6c', component.options)
    }
    module.hot.accept("./CheckTag.vue?vue&type=template&id=1ca22a6c&scoped=true&", function () {
      api.rerender('1ca22a6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/CheckTag.vue"
export default component.exports